import { ShieldCheck, Route, Clock3, MessagesSquare } from "lucide-react";
import Reveal from "./Reveal";

const ITEMS = [
  {
    icon: ShieldCheck,
    title: "Guia credenciado",
    text: "Cadastur 19.967376.16-7. Guia de turismo habilitado, com condução responsável em todos os passeios.",
  },
  {
    icon: Route,
    title: "Roteiros personalizados",
    text: "Experiências montadas de acordo com o seu perfil, seu tempo e os lugares que você deseja visitar.",
  },
  {
    icon: Clock3,
    title: "Passeios completos",
    text: "Experiências de 3 a 8 horas, com busca e retorno na sua hospedagem.",
  },
  {
    icon: MessagesSquare,
    title: "Atendimento personalizado",
    text: "Contato direto com o próprio guia, do primeiro olá no WhatsApp até o fim do passeio.",
  },
];

export default function Highlights() {
  return (
    <section className="relative mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32" data-testid="highlights-section">
      <Reveal>
        <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-amber-400">
          Darlei Guia RJ
        </p>
        <h2 className="mt-4 max-w-3xl font-display text-3xl font-extrabold leading-tight tracking-tight text-stone-50 sm:text-4xl lg:text-5xl">
          Conforto, praticidade e o Rio{" "}
          <em className="font-accent font-medium italic text-amber-400">no seu ritmo.</em>
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {ITEMS.map((item, i) => (
          <Reveal key={item.title} delay={i * 0.12}>
            <article className="group h-full rounded-2xl border border-white/10 bg-[#161B22] p-7 transition-[border-color,transform] duration-500 hover:-translate-y-1.5 hover:border-amber-400/40">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-amber-400/30 bg-[#0D1117] transition-colors duration-500 group-hover:border-amber-400/60">
                <item.icon className="h-5 w-5 text-amber-400" />
              </div>
              <h3 className="mt-6 font-display text-lg font-bold text-stone-50">{item.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-stone-400">{item.text}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
